export default __webpack_public_path__ + "static/media/09_photo.bee1218c.jpg";